import { Inject, Injectable } from '@angular/core';
import { UserModel } from '../../../modules/auth/_models/user.model';
import { OKTA_AUTH, OktaAuthStateService } from '@okta/okta-angular';
import { Observable, of } from 'rxjs';
import { AuthState, OktaAuth } from '@okta/okta-auth-js';
import { filter, map, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { EppOrgaService } from '../contrat/orga/epp-orga.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    private user: UserModel = new UserModel();

    constructor(
        private _oktaAuthStateService: OktaAuthStateService,
        @Inject(OKTA_AUTH) private _oktaAuth: OktaAuth,
        private http: HttpClient,
        private eppOrgaService: EppOrgaService
    ) { }


    public getConnectedUser(): Observable<UserModel> {
        return this._oktaAuthStateService.authState$.pipe(
            filter((authState: AuthState) => !!authState && !!authState.isAuthenticated),
            switchMap((authState: AuthState) => {
                this.user.employeeNumber = authState.accessToken?.claims.employeeNumber?.toString() ?? '';
                this.user.email = authState.idToken?.claims.email ?? '';
                this.user.firstname = authState.accessToken?.claims?.firstName?.toString() ?? '';
                this.user.lastname = authState.accessToken?.claims?.lastName?.toString() ?? '';
                this.user.countryIsoCode = authState.accessToken?.claims.country?.toString() ?? '';
                if(environment.activeEforce){
                    return this.eppOrgaService.getEmployeeByEmployeeNumber(this.user.employeeNumber).pipe(
                        map(res => {
                            this.user.isEforceEmployee = res.isEforceEmployee;
                            this.user.elisPlantCode = res.elisPlantCode;
                            this.user.commercialRoles = (res.roles ?? []).map(r => r.code).filter(Boolean);
                            return this.user;
                        })
                    );
                }else{
                     this.user.isEforceEmployee = false;
                     return of(this.user);
                }
            })
        )as Observable<UserModel>;
    }

    public isAuthenticated: Observable<boolean> = this._oktaAuthStateService.authState$.pipe(
        map((authState: AuthState) => !!authState && !!authState.isAuthenticated)
    );

    logout() {
        this._oktaAuth.signOut()
    }

    handleTokenExpired() {
        this._oktaAuth.signOut();
    }

}
